import React, { useState } from 'react';
import { InstagramIcon } from 'lucide-react';
export function StatsSection() {
  const [activeTab, setActiveTab] = useState('tiktok');
  return <section className="w-full bg-white py-20" data-id="element-1401">
      <div className="container mx-auto px-6" data-id="element-1402">
        <h2 className="text-3xl font-normal text-black mb-16" data-id="element-1403">
          Audiencia y Alcance
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-20" data-id="element-1404">
          <div className="bg-gray-50 p-8 rounded-lg" data-id="element-1405">
            <h3 className="text-xl font-normal text-black mb-8 flex items-center" data-id="element-1406">
              <a href="https://www.tiktok.com/@explorandoconfran" target="_blank" rel="noopener noreferrer" className="flex items-center hover:text-gray-700 transition-colors" data-id="element-1407">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/if4RacDtbfddqkvrotpJLk/tiktok-logo-thin.svg" alt="TikTok logo" className="h-6 w-6 mr-2" data-id="element-1408" />
                TikTok
              </a>
            </h3>
            <p className="text-base text-gray-700 mb-8 leading-relaxed" data-id="element-1409">
              En TikTok, las personas se quedan porque sienten que el viaje es
              real: el aire frío en la cara, los colores de un amanecer, pero
              también esas preguntas que uno se hace en silencio mientras
              avanza. En los últimos 60 días, más de{' '}
              <span className="font-medium" data-id="element-1410">299 mil vistas</span> de una
              comunidad compuesta mayoritariamente por{' '}
              <span className="font-medium" data-id="element-1411">mujeres (69%)</span> que buscan
              inspiración para conocer nuevos lugares… y encontrarse a sí mismas
              en el camino.
            </p>
            <div className="grid grid-cols-2 gap-10" data-id="element-1412">
              <div data-id="element-1413">
                <p className="text-4xl font-normal text-black mb-2" data-id="element-1414">10K</p>
                <p className="text-sm text-gray-600" data-id="element-1415">Seguidores</p>
              </div>
              <div data-id="element-1416">
                <p className="text-4xl font-normal text-black mb-2" data-id="element-1417">
                  <span className="font-medium" data-id="element-1418">299K</span>
                </p>
                <p className="text-sm text-gray-600" data-id="element-1419">
                  Visualizaciones (últimos 60 días)
                </p>
              </div>
              <div data-id="element-1420">
                <p className="text-4xl font-normal text-black mb-2" data-id="element-1421">
                  <span className="font-medium" data-id="element-1422">91.6%</span>
                </p>
                <p className="text-sm text-gray-600" data-id="element-1423">
                  Audiencia en México <br data-id="element-1424" />
                  (por ubicación geográfica)
                </p>
              </div>
              <div data-id="element-1425">
                <p className="text-4xl font-normal text-black mb-2" data-id="element-1426">
                  <span className="font-medium" data-id="element-1427">69%</span>
                </p>
                <p className="text-sm text-gray-600" data-id="element-1428">
                  Audiencia Femenina <br data-id="element-1429" />
                  (por género)
                </p>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 p-8 rounded-lg" data-id="element-1430">
            <h3 className="text-xl font-normal text-black mb-8 flex items-center" data-id="element-1431">
              <a href="https://www.instagram.com/explorandoconfran" target="_blank" rel="noopener noreferrer" className="flex items-center hover:text-gray-700 transition-colors" data-id="element-1432">
                <InstagramIcon className="h-6 w-6 mr-2 stroke-1" data-id="element-1433" />
                Instagram
              </a>
            </h3>
            <p className="text-base text-gray-700 mb-8 leading-relaxed" data-id="element-1434">
              Instagram es como un cuaderno de viaje abierto. El{' '}
              <span className="font-medium" data-id="element-1435">75%</span> de las miradas llegan por
              historias que no solo muestran paisajes, sino momentos que invitan
              a reflexionar. Más de{' '}
              <span className="font-medium" data-id="element-1436">54 mil personas</span> han visto
              estos relatos en tres meses, y muchas me han escrito para contarme
              que no solo viajaron, también tomaron decisiones que les cambiaron
              la vida.
            </p>
            <div className="grid grid-cols-2 gap-10" data-id="element-1437">
              <div data-id="element-1438">
                <p className="text-4xl font-normal text-black mb-2" data-id="element-1439">7.6K</p>
                <p className="text-sm text-gray-600" data-id="element-1440">Seguidores</p>
              </div>
              <div data-id="element-1441">
                <p className="text-4xl font-normal text-black mb-2" data-id="element-1442">
                  <span className="font-medium" data-id="element-1443">127K</span>
                </p>
                <p className="text-sm text-gray-600" data-id="element-1444">
                  Visualizaciones (últimos 90 días)
                </p>
              </div>
              <div data-id="element-1445">
                <p className="text-4xl font-normal text-black mb-2" data-id="element-1446">
                  <span className="font-medium" data-id="element-1447">54K</span>
                </p>
                <p className="text-sm text-gray-600" data-id="element-1448">
                  Cuentas alcanzadas <br data-id="element-1449" />
                  (Incluye seguidores y no seguidores)
                </p>
              </div>
              <div data-id="element-1450">
                <p className="text-4xl font-normal text-black mb-2" data-id="element-1451">
                  <span className="font-medium" data-id="element-1452">74.9%</span>
                </p>
                <p className="text-sm text-gray-600" data-id="element-1453">
                  Contenido en Stories <br data-id="element-1454" />
                  (por formato)
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Tabs for Demographics */}
        <div className="mb-16 bg-gray-50 p-10 rounded-lg" data-id="element-1455">
          <h3 className="text-xl font-normal text-black mb-6" data-id="element-1456">Demografía</h3>
          {/* Tab Navigation */}
          <div className="flex border-b border-gray-200 mb-8" data-id="element-1457">
            <button className={`py-3 px-6 text-sm font-medium ${activeTab === 'tiktok' ? 'border-b-2 border-black text-black' : 'text-gray-500 hover:text-black'}`} onClick={() => setActiveTab('tiktok')} data-id="element-1458">
              TikTok
            </button>
            <button className={`py-3 px-6 text-sm font-medium ${activeTab === 'instagram' ? 'border-b-2 border-black text-black' : 'text-gray-500 hover:text-black'}`} onClick={() => setActiveTab('instagram')} data-id="element-1459">
              Instagram
            </button>
          </div>
          {/* TikTok Tab Content */}
          {activeTab === 'tiktok' && <div data-id="element-1460">
              <p className="text-base text-gray-700 mb-10 leading-relaxed" data-id="element-1461">
                En TikTok, la mayoría son mujeres jóvenes que viven en México,
                con una energía que mezcla sueños y ganas de descubrir. Más de
                la mitad están entre los 25 y 34 años, en ese momento de la vida
                en que se viaja tanto por fuera como por dentro. Y aunque la
                comunidad es mayoritariamente mexicana, siempre hay viajeros
                curiosos que se conectan desde otros rincones del mundo.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-16" data-id="element-1462">
                <div data-id="element-1463">
                  <h4 className="text-base font-medium text-black mb-6" data-id="element-1464">
                    Género
                  </h4>
                  <div className="h-2 bg-gray-200 mb-6 rounded-full" data-id="element-1465">
                    <div className="h-full bg-black rounded-full" style={{
                  width: '69%'
                }} data-id="element-1466"></div>
                  </div>
                  <div className="flex justify-between text-sm" data-id="element-1467">
                    <span className="text-gray-600" data-id="element-1468">
                      Femenino: <span className="font-medium" data-id="element-1469">69%</span>
                    </span>
                    <span className="text-gray-600" data-id="element-1470">
                      Masculino: <span className="font-medium" data-id="element-1471">31%</span>
                    </span>
                  </div>
                </div>
                <div data-id="element-1472">
                  <h4 className="text-base font-medium text-black mb-6" data-id="element-1473">
                    Edad
                  </h4>
                  <div className="space-y-6" data-id="element-1474">
                    <div data-id="element-1475">
                      <div className="flex justify-between text-sm mb-3" data-id="element-1476">
                        <span className="text-gray-600" data-id="element-1477">25-34 años</span>
                        <span className="text-gray-600" data-id="element-1478">
                          <span className="font-medium" data-id="element-1479">56.2%</span>
                        </span>
                      </div>
                      <div className="h-2 bg-gray-200 rounded-full" data-id="element-1480">
                        <div className="h-full bg-black rounded-full" style={{
                      width: '56.2%'
                    }} data-id="element-1481"></div>
                      </div>
                    </div>
                    <div data-id="element-1482">
                      <div className="flex justify-between text-sm mb-3" data-id="element-1483">
                        <span className="text-gray-600" data-id="element-1484">18-24 años</span>
                        <span className="text-gray-600" data-id="element-1485">
                          <span className="font-medium" data-id="element-1486">24.2%</span>
                        </span>
                      </div>
                      <div className="h-2 bg-gray-200 rounded-full" data-id="element-1487">
                        <div className="h-full bg-black rounded-full" style={{
                      width: '24.2%'
                    }} data-id="element-1488"></div>
                      </div>
                    </div>
                    <div data-id="element-1489">
                      <div className="flex justify-between text-sm mb-3" data-id="element-1490">
                        <span className="text-gray-600" data-id="element-1491">35-44 años</span>
                        <span className="text-gray-600" data-id="element-1492">
                          <span className="font-medium" data-id="element-1493">15.2%</span>
                        </span>
                      </div>
                      <div className="h-2 bg-gray-200 rounded-full" data-id="element-1494">
                        <div className="h-full bg-black rounded-full" style={{
                      width: '15.2%'
                    }} data-id="element-1495"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-id="element-1496">
                  <h4 className="text-base font-medium text-black mb-6" data-id="element-1497">
                    Ubicación geográfica
                  </h4>
                  <div className="space-y-6" data-id="element-1498">
                    <div data-id="element-1499">
                      <div className="flex justify-between text-sm mb-3" data-id="element-1500">
                        <span className="text-gray-600" data-id="element-1501">México</span>
                        <span className="text-gray-600" data-id="element-1502">
                          <span className="font-medium" data-id="element-1503">91.6%</span>
                        </span>
                      </div>
                      <div className="h-2 bg-gray-200 rounded-full" data-id="element-1504">
                        <div className="h-full bg-black rounded-full" style={{
                      width: '91.6%'
                    }} data-id="element-1505"></div>
                      </div>
                    </div>
                    <div data-id="element-1506">
                      <div className="flex justify-between text-sm mb-3" data-id="element-1507">
                        <span className="text-gray-600" data-id="element-1508">Otros países</span>
                        <span className="text-gray-600" data-id="element-1509">
                          <span className="font-medium" data-id="element-1510">5.8%</span>
                        </span>
                      </div>
                      <div className="h-2 bg-gray-200 rounded-full" data-id="element-1511">
                        <div className="h-full bg-black rounded-full" style={{
                      width: '5.8%'
                    }} data-id="element-1512"></div>
                      </div>
                    </div>
                    <div data-id="element-1513">
                      <div className="flex justify-between text-sm mb-3" data-id="element-1514">
                        <span className="text-gray-600" data-id="element-1515">España</span>
                        <span className="text-gray-600" data-id="element-1516">
                          <span className="font-medium" data-id="element-1517">1.0%</span>
                        </span>
                      </div>
                      <div className="h-2 bg-gray-200 rounded-full" data-id="element-1518">
                        <div className="h-full bg-black rounded-full" style={{
                      width: '1.0%'
                    }} data-id="element-1519"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>}
          {/* Instagram Tab Content */}
          {activeTab === 'instagram' && <div data-id="element-1520">
              <p className="text-base text-gray-700 mb-10 leading-relaxed" data-id="element-1521">
                En Instagram, el viaje se cuenta distinto. La audiencia está
                casi mitad y mitad entre hombres y mujeres, como si todos se
                reunieran alrededor de la misma fogata a escuchar historias. Es
                una comunidad que llega no solo por las fotos, sino por esos
                relatos que invitan a quedarse y conversar un rato más.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-16" data-id="element-1522">
                <div data-id="element-1523">
                  <h4 className="text-base font-medium text-black mb-6" data-id="element-1524">
                    Género
                  </h4>
                  <div className="h-2 bg-gray-200 mb-6 rounded-full" data-id="element-1525">
                    <div className="h-full bg-black rounded-full" style={{
                  width: '50.7%'
                }} data-id="element-1526"></div>
                  </div>
                  <div className="flex justify-between text-sm" data-id="element-1527">
                    <span className="text-gray-600" data-id="element-1528">
                      Masculino: <span className="font-medium" data-id="element-1529">50.7%</span>
                    </span>
                    <span className="text-gray-600" data-id="element-1530">
                      Femenino: <span className="font-medium" data-id="element-1531">49.3%</span>
                    </span>
                  </div>
                </div>
                <div data-id="element-1532">
                  <h4 className="text-base font-medium text-black mb-6" data-id="element-1533">
                    Edad
                  </h4>
                  <div className="space-y-6" data-id="element-1534">
                    <div data-id="element-1535">
                      <div className="flex justify-between text-sm mb-3" data-id="element-1536">
                        <span className="text-gray-600" data-id="element-1537">25-34 años</span>
                        <span className="text-gray-600" data-id="element-1538">
                          <span className="font-medium" data-id="element-1539">48.5%</span>
                        </span>
                      </div>
                      <div className="h-2 bg-gray-200 rounded-full" data-id="element-1540">
                        <div className="h-full bg-black rounded-full" style={{
                      width: '48.5%'
                    }} data-id="element-1541"></div>
                      </div>
                    </div>
                    <div data-id="element-1542">
                      <div className="flex justify-between text-sm mb-3" data-id="element-1543">
                        <span className="text-gray-600" data-id="element-1544">18-24 años</span>
                        <span className="text-gray-600" data-id="element-1545">
                          <span className="font-medium" data-id="element-1546">32.3%</span>
                        </span>
                      </div>
                      <div className="h-2 bg-gray-200 rounded-full" data-id="element-1547">
                        <div className="h-full bg-black rounded-full" style={{
                      width: '32.3%'
                    }} data-id="element-1548"></div>
                      </div>
                    </div>
                    <div data-id="element-1549">
                      <div className="flex justify-between text-sm mb-3" data-id="element-1550">
                        <span className="text-gray-600" data-id="element-1551">35-44 años</span>
                        <span className="text-gray-600" data-id="element-1552">
                          <span className="font-medium" data-id="element-1553">14.2%</span>
                        </span>
                      </div>
                      <div className="h-2 bg-gray-200 rounded-full" data-id="element-1554">
                        <div className="h-full bg-black rounded-full" style={{
                      width: '14.2%'
                    }} data-id="element-1555"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-id="element-1556">
                  <h4 className="text-base font-medium text-black mb-6" data-id="element-1557">
                    Ubicación geográfica
                  </h4>
                  <div className="space-y-6" data-id="element-1558">
                    <div data-id="element-1559">
                      <div className="flex justify-between text-sm mb-3" data-id="element-1560">
                        <span className="text-gray-600" data-id="element-1561">México</span>
                        <span className="text-gray-600" data-id="element-1562">
                          <span className="font-medium" data-id="element-1563">88.3%</span>
                        </span>
                      </div>
                      <div className="h-2 bg-gray-200 rounded-full" data-id="element-1564">
                        <div className="h-full bg-black rounded-full" style={{
                      width: '88.3%'
                    }} data-id="element-1565"></div>
                      </div>
                    </div>
                    <div data-id="element-1566">
                      <div className="flex justify-between text-sm mb-3" data-id="element-1567">
                        <span className="text-gray-600" data-id="element-1568">Estados Unidos</span>
                        <span className="text-gray-600" data-id="element-1569">
                          <span className="font-medium" data-id="element-1570">6.2%</span>
                        </span>
                      </div>
                      <div className="h-2 bg-gray-200 rounded-full" data-id="element-1571">
                        <div className="h-full bg-black rounded-full" style={{
                      width: '6.2%'
                    }} data-id="element-1572"></div>
                      </div>
                    </div>
                    <div data-id="element-1573">
                      <div className="flex justify-between text-sm mb-3" data-id="element-1574">
                        <span className="text-gray-600" data-id="element-1575">Colombia</span>
                        <span className="text-gray-600" data-id="element-1576">
                          <span className="font-medium" data-id="element-1577">2.8%</span>
                        </span>
                      </div>
                      <div className="h-2 bg-gray-200 rounded-full" data-id="element-1578">
                        <div className="h-full bg-black rounded-full" style={{
                      width: '2.8%'
                    }} data-id="element-1579"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>}
        </div>
      </div>
    </section>;
}